// extracted by mini-css-extract-plugin
module.exports = {"ctaButtonWrapper":"DesignCtaButton_ctaButtonWrapper__lw08J","ctaButtonText":"DesignCtaButton_ctaButtonText__I_HWS","ctaButtonIcon":"DesignCtaButton_ctaButtonIcon__VYubk"};